import { CREATE_PAYMENT_REQUEST, CREATE_PAYMENT_SUCCESS, CREATE_PAYMENT_FAIL, CREATE_PAYMENT_RESET, GET_RECENT_PAYMENT_FAIL, GET_RECENT_PAYMENT_SUCCESS, GET_RECENT_PAYMENT_REQUEST, VERIFY_PAYMENT_REQUEST, VERIFY_PAYMENT_SUCCESS, VERIFY_PAYMENT_FAIL } from "../constants/payment";
import axios from "axios";
import { baseUrl } from "./baseUrl";
import axiosInstance from "../../axiosInstance";

export const createPayment = (patient, amount, reference, location, notes, appointmentData = null) => async (dispatch) => {
    try {
        dispatch({
            type: CREATE_PAYMENT_REQUEST,
        });
   
        let config;
        
        if (appointmentData) {
            config = {
                method: 'post',
                url: `/payments/appointments`,
                data: {
                    patient,
                    amount,
                    reference,
                    location,
                    notes,
                    ...appointmentData
                    // appointmentData: {
                    //     clinic_id: appointmentData.clinic_id,
                    //     clinic_name: appointmentData.clinic_name,
                    //     appt_date: appointmentData.appt_date,
                    //     appt_time: appointmentData.appt_time,
                    //     appt_mode: appointmentData.appt_mode,
                    //     appt_type: appointmentData.appt_type,
                    //     appt_url: appointmentData.appt_url,
                    //     notes: appointmentData.notes,
                    //     patient: appointmentData.patient,
                    //     location: appointmentData.location
                    // }
                }
            };
        } else {
            config = {
                method: 'post',
                url: `/payments?patient=${patient}&amount=${amount}&reference=${reference}&location=${location}&notes=${notes}`
            };
        }
        
        const { data } = await axiosInstance.request(config);

        dispatch({
            type: CREATE_PAYMENT_SUCCESS,
            payload: data,
        });
    } catch (err) {
        let message =
            err.response && err.response.data.errors
                ? err.response.data.errors
                : err.message;
        dispatch({
            type: CREATE_PAYMENT_FAIL,
            payload: message,
        });

    }
};

export const getRecentPayments = (patient) => async (dispatch) => {
    try {
        dispatch({
            type: GET_RECENT_PAYMENT_REQUEST,
        });
 
        const { data } = await axiosInstance.get(
            `/payments/recent?patient=${patient}`
        );

        dispatch({
            type: GET_RECENT_PAYMENT_SUCCESS,
            payload: data,
        });
    } catch (err) {
        let message =
            err.response && err.response.data.errors
                ? err.response.data.errors
                : err.message;
        dispatch({
            type: GET_RECENT_PAYMENT_FAIL,
            payload: message,
        });

    }
}

export const verifyPayment = (reference) => async (dispatch) => {
    try {
        dispatch({
            type: VERIFY_PAYMENT_REQUEST,
        });
 
        const { data } = await axiosInstance.get(
            `/payments/verify?reference=${reference}`
        );

        dispatch({
            type: VERIFY_PAYMENT_SUCCESS,
            payload: data,
        });
        
        return data;
    } catch (err) {
        let message =
            err.response && err.response.data.errors
                ? err.response.data.errors
                : err.message;
        dispatch({
            type: VERIFY_PAYMENT_FAIL,
            payload: message,
        });
        
        throw err;
    }
}

export const resetPayment = () => (dispatch) => {
    dispatch({
        type: CREATE_PAYMENT_RESET,
    });
}
